import { all, takeLatest } from 'redux-saga/effects';

import { getAccessToken } from 'store/api/sagas/getAccessToken';

import * as actionTypes from '../actionTypes';

export default function* watchAPI() {
    yield all([takeLatest(actionTypes.GET_ACCESS_TOKEN_REQUEST, getAccessToken)]);
}
